import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ColumnCellRendererParams } from './column_cell_renderer_params.interface';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { PropertyViewModelInterface } from '@nts/std/interfaces';

@Component({template:''})
export abstract class BaseCellRendererComponent implements AgRendererComponent, OnInit, OnDestroy {

    @Input()
    params: ICellRendererParams;

    protected destroy$: Subject<boolean> = new Subject<boolean>();

    // Supporto dei componenti usati anche inclusi in altri componenti di template vedi dynamic
    ngOnInit(): void {
        if (this.params) {
            this.agInit(this.params);
        }
    }

    refresh(params: any): boolean {
        return true;
    }

    agInit(params: any): void {
        this.params = params;
    }

    private _propertyViewModel: PropertyViewModelInterface;

    get propertyViewModel(): PropertyViewModelInterface {
        if (!this._propertyViewModel) {
            this._propertyViewModel = (this.params as ColumnCellRendererParams).columnInfo.fieldName.split('.').reduce(
                (o, i) => {
                    if (i === 'value') {
                        return o;
                    }
                    if (o != null) {
                        return o[i];
                    }
                    return null;
                }, this.params.data) as PropertyViewModelInterface;
        }
        return this._propertyViewModel;
    }

    ngOnDestroy(): void {
      this.destroy$.next(true);
      // Now let's also unsubscribe from the subject itself:
      this.destroy$.unsubscribe();
    }
}
